/* eslint-disable react/no-unknown-property */
import { Canvas, useFrame } from "@react-three/fiber";
import { Center, Edges, OrbitControls , useGLTF } from "@react-three/drei";
import React, { useRef } from "react";
import logoModel  from "../../assets/model/swan-transformed.glb";

export default function AnimatedLogo({animationColor}) {
    return (
      <Canvas>
          <Model animationColor={animationColor} />
        </Canvas>
    )
}

export function Model({animationColor}) {
    const { nodes } = useGLTF(logoModel);
    const ref = useRef(null);
  
    useFrame(() => {
      if (ref.current) {
        ref.current.rotation.y += 0.005;
      }
    });
    return (
      <>
        <Center ref={ref}>
          <group dispose={null}>
            <pointLight />
            <mesh geometry={(nodes.Shape_0).geometry} scale={0.018}>
              <meshBasicMaterial transparent opacity={0} />
              <Edges scale={1} threshold={80} color={animationColor || 'white'} />
            </mesh>
          </group>
        </Center>
        <OrbitControls enableZoom={false} enablePan={false} />
      </>
    );
  }
  
  useGLTF.preload(logoModel);